export const skillCategories = {
  Frontend: [
    "React",
    "Angular",
    "JavaScript",
    "TypeScript",
    "HTML",
    "CSS",
    "SCSS",
    "Tailwind",
    "Vite",
    "GraphQL",
  ],
  Backend: ["Python", "Java", "C#", "Node.js", "SQL", "GraphQL"],
  "Tools & DevOps": [
    "Cursor",
    "Git",
    "AWS",
    "Azure",
    "CI/CD",
  ],
  "Cloud Resources": [
    "Docker",
    "MongoDB",
    "SQL",
    "DocumentDB",
    "S3",
    "DynamoDB",
  ],
  "AI & Automation": [
    "Applied AI",
    "Bedrock",
    "Agentic Workflows",
    "LLM APIs",
    "OpenRouter",
  ],
  Leadership: [
    "Technical Leadership",
    "Team Organization",
    "Mentorship",
    "Technical Ownership",
    "Engineering Standards",
  ],
  Collaboration: [
    "Customer & Partner Facing",
    "Product Discovery",
    "Stakeholder Communication",
    "Cross-Functional Collaboration",
  ],
};
